import { NgClass, NgIf } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';

// SAI PATCH: restyled onto the SAI design system (.sai-confirm in
// _sai-components.scss) so every confirmation popup shares one token-driven,
// RTL-safe, light/dark shell. Width now comes from the sai-dialog-sm panel
// class instead of the stock w-128, the surface corner follows the radius
// scale rather than Material's default, and the account's own colour (the
// tenant --c1/--c2 gradient) drives the confirm button and the icon tile;
// Material's palette `color` is never used because it is not the tenant's.
@Component({
    selector     : 'fuse-confirmation-dialog',
    templateUrl  : './dialog.component.html',
    styles       : [
        `
            .fuse-confirmation-dialog-panel {

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                        border-radius: var(--sai-radius-lg);
                        box-shadow: var(--sai-shadow-lg);
                    }
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [NgIf, MatButtonModule, MatDialogModule, MatIconModule, NgClass],
})
export class FuseConfirmationDialogComponent
{
    /**
     * Ids the service also hands to MatDialog as ariaLabelledBy/ariaDescribedBy,
     * so a screen reader announces the question when the dialog opens.
     */
    readonly titleId: string;
    readonly messageId: string;

    /**
     * Constructor
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: FuseConfirmationConfig)
    {
        this.titleId = data.titleId ?? 'fuse-confirmation-title';
        this.messageId = data.messageId ?? 'fuse-confirmation-message';
    }

    /**
     * The confirm button wears the account gradient unless the action is
     * destructive, where it takes the danger token instead.
     */
    get confirmClass(): string
    {
        return this.data.actions?.confirm?.color === 'warn'
            ? 'sai-confirm__confirm--danger'
            : 'bg-primary';
    }

}
